import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ApiService } from '../Services/apiServices';
import { showToast } from '../Utlis/toastUtlis';
import BottomNavigation from '../BottomNavigation';

const Footer = () => {

    const [settings, setSettings] = useState("");
    const [company, setCompany] = useState([]);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        const fetchsettings = async () => {
            try {
                const settingData = await ApiService.Commanfetchrequest('setting');
                setSettings(settingData);
                // console.log('setting data:', settingData);
            } catch (error) {
                console.log('error while fetching:', error);
            }
        }


        const fetchcompany = async () => {
            try {
                const companyData = await ApiService.Commanfetchrequest('company');
                setCompany(companyData);
                // console.log('company data:', companyData);
            } catch (error) {
                console.log('error while fetching:', error);
            }
        }


        fetchsettings();
        fetchcompany();
    }, []);


    return (
        <div>
            <BottomNavigation />
            <div className="container-fluid footer mt-5" style={{backgroundColor:"#F7F7F7", color:"black"}}>
                <div className="container pb-5">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="rounded">
                                <a href="/" style={{ textDecoration: 'none' }}>
                                    <h2 className="text-white mb-2"><span style={{ color: 'green', fontWeight:"700" }}>FamilyFun</span></h2>
                                </a>
                                <p className="text-black mb-0">
                                    At FamilyFun, we redefine luxury and comfort with our premium home stay services. Whether you're traveling for leisure or business, our elegantly designed accommodations offer the perfect blend of warmth, privacy, and
                                    top-notch hospitality.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h6 className="section-title text-start text-primary text-uppercase mb-4">Contact</h6>
                            <p className="mb-2">
                                <i className="fa fa-map-marker-alt me-3" />
                                <a href="https://www.google.com/maps/search/?q=Jagatpura%2C%20Jaipur%20-%20302017" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'black' }}>Jaipur - 302017</a>
                            </p>
                            <p className="mb-2"><i className="fa fa-phone-alt me-3" /><a href="tel:9079762817" style={{ textDecoration: 'none', color: 'black' }}>9079762817</a></p>
                            <p className="mb-2"><i className="fa fa-envelope me-3" /><a href="" style={{ textDecoration: 'none', color: 'black' }}>info@familyFun.in</a></p>
                            <div className="d-flex pt-2">
                                <a className="btn btn-outline-light btn-social" href="https://x.com/?lang=en" target="new"><i className="fab fa-twitter" /></a>
                                <a className="btn btn-outline-light btn-social" href="https://www.facebook.com/" target="new"><i className="fab fa-facebook-f" /></a>
                                <a className="btn btn-outline-light btn-social" href="https://www.instagram.com/" target="new"><i className="fab fa-instagram" /></a>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="row gy-5 g-4">
                                <div className="col-md-6">
                                    <h6 className="section-title text-start text-primary text-uppercase mb-4">Quick Links</h6>
                                    <Link className="btn btn-link" to="/about-us" data-discover="true">
                                    About Us
                                    </Link>
                                    <Link className="btn btn-link" to="/contact-us" data-discover="true">
                                    Contact Us
                                    </Link>
                                    <Link className="btn btn-link" to="/privacy-policy" data-discover="true">
                                    Privacy Policy</Link>
                                    <Link className="btn btn-link" to="/terms-conditions" data-discover="true">
                                    Term &amp; Conditions
                                    </Link>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6 text-center" style={{ marginBottom: 35 }}>
                                © <a className="border-bottom" href="/" data-discover="true">FamilyFun</a>, All Right Reserved 
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    )
}

export default Footer
